import createClient from "openapi-fetch";
import { VOISLOG_API_URL } from "../../environments";
import type { paths } from "../../types/voislog_api";
import {
  wafMiddleware,
  authMiddleware,
  variantTunnelMiddleware,
  apiErrorMiddleware,
} from "./index";

// スキーマ未公開のAPIエンドポイント定義
type privatePaths = {
  "/v2/core/auth/google/token": {
    post: {
      requestBody: { content: { "application/json": { credential: string } } };
      responses: {
        200: { content: { "application/json": { access_token: string } } };
      };
    };
  };
  "/v2/core/policies/users/me/agreements": {
    get: {
      responses: {
        200: {
          content: {
            "application/json": {
              terms: PolicyAgreement;
              privacy: PolicyAgreement;
            };
          };
        };
      };
    };
    post: {
      requestBody: {
        content: {
          "application/json": {
            privacy?: number | null;
            terms?: number | null;
          };
        };
      };
      responses: { 200: { content: { "application/json": object } } };
    };
  };
};

type PolicyAgreement = {
  version: number | null;
  url: string | null;
  user_agreement: number | null;
};

export type VoislogPaths = paths & privatePaths;

export const voislogApi = createClient<VoislogPaths>({
  baseUrl: VOISLOG_API_URL,
  headers: { "X-App-Id": "vAnalysis", "X-App-Version": __APP_VERSION__ },
});

// openapi-fetchのonResponseは登録順と逆順に実行されるため、
// wafMiddlewareを最優先で実行させるには最後に登録する
// apiErrorMiddlewareはWAF判定の後に残った非2xxを拾うため、wafMiddlewareの直前に登録する
voislogApi.use(authMiddleware);
voislogApi.use(variantTunnelMiddleware);
voislogApi.use(apiErrorMiddleware);
voislogApi.use(wafMiddleware);
